import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_dock_door_editorService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { locationId: number }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsPrimaryPick?: boolean, Name?: string, ParentId?: number, ShortName?: string, StatusId?: number, WarehouseId?: number, Status?: { Name?: string }, ChildLocationContainers?: { Id?: number, IsLoose?: boolean, Name?: string }[], ParentLocationContainer?: { Id?: number, Name?: string, TypeId?: number } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.locationId)) {
      missingRequiredInParams.push('\'locationId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_dock_door_editor/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
